export default __webpack_public_path__ + "static/media/hiw-slide-3.f0ca91ad.png";